import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ImageReveal } from "../motion/Reveal.jsx";

export default function FacilityCard({ facility, index, className = "", highlighted = false }) {
  return (
    <Link
      id={`facility-${facility.id}`}
      data-testid={`facility-card-${facility.id}`}
      to="/contact"
      className={`group flex h-full flex-col overflow-hidden rounded-xl border bg-white transition-all duration-300 hover:border-brand/60 hover:shadow-[0_28px_60px_-28px_rgba(11,25,44,0.35)] ${
        highlighted ? "z-20 border-brand ring-2 ring-brand ring-offset-2" : "border-hairline"
      } ${className}`}
    >
      <ImageReveal
        src={facility.image}
        alt={`${facility.name} at Oneiros Sports Club Surat`}
        className="w-full aspect-[4/3]"
      />
      <div className="flex flex-1 flex-col gap-2 p-6">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="font-display text-2xl text-navy">{facility.name}</h3>
          <span className="font-display text-lg text-faint">{String(index + 1).padStart(2, "0")}</span>
        </div>
        <p className="text-sm leading-relaxed text-mute">{facility.description}</p>
        <span className="mt-auto inline-flex items-center gap-2 pt-3 text-[11px] font-bold uppercase tracking-[0.2em] text-navy transition-colors duration-300 group-hover:text-brand">
          Enquire
          <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  );
}
